/* CALE & CAEL — Size & Fit guide (vanilla JS, no dependencies) */
(function () {
  var FITS = [
    { id: 'super-slim', label: 'Super Slim Fit', delta: 0, key: 'superSlim',
      blurb: 'Our closest-fitting silhouette. Narrower at the chest, arms and waist, for a considerably slimmer fit. Designed especially for those with a slim build or clients who prefer a very close fit with an ultra-trim silhouette, this option highlights modern aesthetics and promotes a sleek, streamlined appearance.',
      note: '', scale: 0.94 },
    { id: 'slim', label: 'Slim Fit', delta: 3, key: 'slim',
      blurb: 'Characterized by a slimmer chest, waist, hip and narrower sleeves. Ideal for clients with an average build looking for a modern, subtly tailored fit. Flattering to most body types for a more tailored silhouette.',
      note: '', scale: 1 },
    { id: 'classic', label: 'Classic Fit', delta: 6, key: 'classic',
      blurb: 'For those with a stockier build or clients who prefer a looser fit. Our Classic Fit offers a traditional silhouette with a fuller back, chest, and waist. This shape is designed for comfort, allowing the client to layer underneath.',
      note: 'Wider sleeves and cuffs complement this proposal, ensuring an optimal, streamlined fit for an audience that values comfort and roominess in their clothing.', scale: 1.07 }
  ];
  var IMAGES = {};


  function row(size, bc, jc, bh, jh, bw, jw, sl) {
    return { size: size, bodyChest: bc, jacketChest: jc, bodyHip: bh, jacketHip: jh,
      bodyWaist: bw, jacketWaist: jw, sleeveShort: sl - 2.54, sleeveStandard: sl, sleeveLong: sl + 2.54 };
  }
  var DEAN = [row('S',98,102,93,98,90,96,63), row('M',102,106,97,102,94,100,64), row('L',107,110,101,106,98,104,65), row('XL',113,115,106,111,103,109,66)];
  var MAV  = [row('S',96,100,91,96,88,94,62),  row('M',100,104,95,100,92,98,63),  row('L',105,108,99,104,96,102,64), row('XL',111,113,104,109,101,107,65)];

  var MODELS = [
    { id: 'dean', name: 'Dean Biker', tagline: 'Classic biker in premium leather', base: DEAN },
    { id: 'dean-2', name: 'Dean Biker 2.0', tagline: 'Biker silhouette with updated detailing', base: DEAN },
    { id: 'dean-two-tone', name: 'Dean Biker Two Tone', tagline: 'Two-tone biker, same Dean pattern', base: DEAN },
    { id: 'maverick', name: 'Maverick Bomber', tagline: 'Contemporary bomber', base: MAV },
    { id: 'maverick-2', name: 'Maverick Bomber 2.0', tagline: 'Refined bomber silhouette', base: MAV },
    { id: 'giacomo', name: 'Giacomo Racer', tagline: 'Racing inspired, clean lines', base: DEAN }
  ];

  var COLS = [
    { key: 'bodyChest', label: 'Your chest', body: true },
    { key: 'jacketChest', label: 'Jacket chest' },
    { key: 'bodyWaist', label: 'Your waist', body: true },
    { key: 'jacketWaist', label: 'Jacket waist' },
    { key: 'bodyHip', label: 'Your hip', body: true },
    { key: 'jacketHip', label: 'Jacket hip' },
    { key: 'sleeveShort', label: 'Short sleeve', sleeve: -1 },
    { key: 'sleeveStandard', label: 'Classic sleeve', popular: true, sleeve: 0 },
    { key: 'sleeveLong', label: 'Long sleeve', sleeve: 1 }
  ];

  function sleeveDelta(dir) {
    if (dir === 0) return 'Standard length';
    return (dir > 0 ? '+' : '\u2212') + (state.unit === 'in' ? '1 in' : '2.54 cm');
  }

  var state = { model: 'dean', fit: 'slim', unit: 'cm', chest: '', locked: false };
  var lastTrigger = null;

  function fit() { for (var i=0;i<FITS.length;i++) if (FITS[i].id === state.fit) return FITS[i]; return FITS[1]; }
  function model() { for (var i=0;i<MODELS.length;i++) if (MODELS[i].id === state.model) return MODELS[i]; return MODELS[0]; }
  function rows() {
    var d = fit().delta;
    return model().base.map(function (r) {
      return Object.assign({}, r, { jacketChest: r.jacketChest + d, jacketHip: r.jacketHip + d, jacketWaist: r.jacketWaist + d });
    });
  }
  function fmt(cm) { return state.unit === 'cm' ? String(Math.round(cm * 10) / 10) : String(Math.round((cm / 2.54) * 2) / 2); }
  function recommended(rs) {
    var v = parseFloat(state.chest); if (isNaN(v)) return null;
    var cm = state.unit === 'cm' ? v : v * 2.54;
    if (cm < 60 || cm > 170) return null;
    for (var i=0;i<rs.length;i++) if (cm <= rs[i].bodyChest) return rs[i].size;
    return rs[rs.length - 1].size;
  }

  function figure(f) {
    var src = IMAGES[f.key] || '';
    return '<span class="sc-fit-figwrap"><img class="sc-fit-img" src="' + src + '" alt="' + f.label +
      ' jacket silhouette" loading="lazy" style="transform:scaleX(' + f.scale + ')"></span>';
  }
  function ease(f) {
    return '<span class="sc-ease" aria-hidden="true"><span class="sc-ease-bar"><span class="sc-ease-fill" style="width:' +
      (20 + f.delta * 12) + '%"></span></span><span class="sc-ease-label">' +
      (f.delta === 0 ? 'Closest to the body' : '+' + f.delta + ' cm room') + '</span></span>';
  }

  function render(root) {
    var rs = rows(), reco = recommended(rs), f = fit(), m = model();
    var nav = root.querySelector('[data-sc-models]');
    if (state.locked) {
      nav.hidden = true;
      nav.innerHTML = '';
    } else {
      nav.hidden = false;
      nav.innerHTML = MODELS.map(function (x) {
        return '<button type="button" class="sc-model' + (x.id === state.model ? ' is-active' : '') + '" data-sc-model="' + x.id + '">' + x.name + '</button>';
      }).join('');
    }
    root.querySelector('[data-sc-model-name]').textContent = m.name;
    root.querySelector('[data-sc-tagline]').textContent = m.tagline;
    root.querySelector('[data-sc-fits]').innerHTML = FITS.map(function (x) {
      return '<button type="button" role="radio" aria-checked="' + (x.id === state.fit) + '" class="sc-fit' + (x.id === state.fit ? ' is-active' : '') + '" data-sc-fit="' + x.id + '">' +
        '<span class="sc-fit-name">' + x.label + '</span>' + figure(x) + ease(x) +
        '<span class="sc-fit-blurb">' + x.blurb + '</span>' +
        (x.note ? '<span class="sc-fit-note">' + x.note + '</span>' : '') +
        '<span class="sc-fit-delta">' + (x.delta === 0 ? 'Base cut' : '+' + x.delta + ' cm ease') + '</span></button>';
    }).join('');
    var detail = root.querySelector('[data-sc-fit-detail]');
    if (detail) {
      detail.innerHTML = '<p class="sc-fit-detail-blurb">' + f.blurb + '</p>' +
        (f.note ? '<p class="sc-fit-detail-note">' + f.note + '</p>' : '') +
        '<span class="sc-fit-detail-delta">' + (f.delta === 0 ? 'Base cut' : '+' + f.delta + ' cm ease') + '</span>';
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-sc-unit]'), function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-sc-unit') === state.unit);
    });
    root.querySelector('[data-sc-unit-label]').textContent = state.unit;
    root.querySelector('[data-sc-input]').placeholder = state.unit === 'cm' ? '102' : '40';
    root.querySelector('[data-sc-reco]').innerHTML = reco
      ? 'Your suggested size in the <strong>' + m.name + '</strong> ' + f.label + ' is <strong class="sc-reco-size">' + reco + '</strong>'
      : 'Enter your chest measurement and we will highlight your size.';
    root.querySelector('[data-sc-thead]').innerHTML = '<tr><th scope="col" class="sc-sticky">Size</th>' + COLS.map(function (c) {
      return '<th scope="col" class="' + (c.body ? 'is-body' : '') + '">' + c.label +
        (typeof c.sleeve === 'number' ? '<span class="sc-sleeve-delta">' + sleeveDelta(c.sleeve) + '</span>' : '') +
        (c.popular ? '<span class="sc-pop">Most chosen</span>' : '') + '</th>';
    }).join('') + '</tr>';
    root.querySelector('[data-sc-tbody]').innerHTML = rs.map(function (r) {
      return '<tr class="' + (r.size === reco ? 'is-reco' : '') + '"><th scope="row" class="sc-sticky">' + r.size +
        (r.size === reco ? '<span class="sc-dot"></span>' : '') + '</th>' +
        COLS.map(function (c) { return '<td class="' + (c.body ? 'is-body' : '') + '">' + fmt(r[c.key]) + '</td>'; }).join('') + '</tr>';
    }).join('');
  }

  function init() {
    var root = document.querySelector('[data-sc-root]');
    if (!root) return;
    var overlay = document.querySelector('[data-sc-overlay]');

    function setModel(id) {
      if (!id) return;
      for (var i=0;i<MODELS.length;i++) if (MODELS[i].id === id) { state.model = id; return; }
    }
    IMAGES = {
      superSlim: root.getAttribute('data-sc-img-super-slim') || '',
      slim: root.getAttribute('data-sc-img-slim') || '',
      classic: root.getAttribute('data-sc-img-classic') || ''
    };
    setModel(root.getAttribute('data-sc-default-model'));
    state.locked = root.getAttribute('data-sc-lock') === 'true';
    var presetFit = root.getAttribute('data-sc-default-fit');
    if (presetFit) for (var k=0;k<FITS.length;k++) if (FITS[k].id === presetFit) state.fit = presetFit;

    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-sc-model],[data-sc-fit],[data-sc-unit]');
      if (!el) return;
      if (el.hasAttribute('data-sc-model')) state.model = el.getAttribute('data-sc-model');
      else if (el.hasAttribute('data-sc-fit')) state.fit = el.getAttribute('data-sc-fit');
      else state.unit = el.getAttribute('data-sc-unit');
      render(root);
    });
    root.addEventListener('input', function (e) {
      if (!e.target.matches('[data-sc-input]')) return;
      state.chest = e.target.value.replace(/[^\d.,]/g, '').replace(',', '.');
      e.target.value = state.chest;
      render(root);
      root.querySelector('[data-sc-input]').focus();
    });

    function open(opts) {
      if (!overlay) return;
      opts = opts || {};
      if (opts.model) { setModel(opts.model); state.locked = true; }
      if (opts.fit) state.fit = opts.fit;
      if (typeof opts.lock === 'boolean') state.locked = opts.lock;
      render(root);
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = overlay.querySelector('[data-sc-close]');
      if (close) close.focus();
    }
    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastTrigger) { try { lastTrigger.focus(); } catch (err) {} lastTrigger = null; }
    }
    window.openSizeChart = open;
    window.closeSizeChart = close;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sc-open]');
      if (trigger) {
        e.preventDefault();
        lastTrigger = trigger;
        open({
          model: trigger.getAttribute('data-sc-model') || undefined,
          fit: trigger.getAttribute('data-sc-fit') || undefined
        });
      }
      if (e.target.closest('[data-sc-close]') || e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Keep the guide in sync with the fit option selected on the product form */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.name) return;
      if (!/fit/i.test(input.name)) return;
      var v = String(input.value || '').toLowerCase();
      if (v.indexOf('super') > -1) state.fit = 'super-slim';
      else if (v.indexOf('slim') > -1) state.fit = 'slim';
      else if (v.indexOf('classic') > -1 || v.indexOf('regular') > -1) state.fit = 'classic';
      if (overlay && overlay.classList.contains('is-open')) render(root);
    });

    render(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
